import { ALL_BUILDING_TYPES, BuildingType } from './BuildingTypeEnums';

/**
 * The building types this instance offers, at `global/enabledBuildingTypes/{type}: true`.
 *
 * Only `true` counts; a missing node or key means the type is off. Set by a
 * superadmin under Instansinställningar. Off types are not offered when a
 * building is created or its type changed, and filters list them only while
 * a building still has that type. Existing buildings are never touched.
 *
 * `global/buildingTypes` (`{enabled, createNew}`) is the legacy node read by
 * iOS releases before this change; the web only reads it to pre-fill the
 * settings of an instance that has no new node yet.
 */
export const ENABLED_BUILDING_TYPES_PATH = 'global/enabledBuildingTypes';
export const LEGACY_BUILDING_TYPES_PATH = 'global/buildingTypes';

/** The enabled types in display order; null when the node is absent (instance not configured). */
export function parseEnabledBuildingTypes(value: unknown): BuildingType[] | null {
    if (value === null || value === undefined) return null;
    if (typeof value !== 'object') return [];
    const node = value as Record<string, unknown>;
    return ALL_BUILDING_TYPES.filter(type => node[type] === true);
}

/** Types with `enabled: true` in the legacy node, or null when it is absent. */
export function parseLegacyBuildingTypes(value: unknown): BuildingType[] | null {
    if (value === null || value === undefined || typeof value !== 'object') return null;
    const node = value as Record<string, unknown>;
    return ALL_BUILDING_TYPES.filter(type => {
        const entry = node[type];
        return typeof entry === 'object' && entry !== null && (entry as Record<string, unknown>).enabled === true;
    });
}
